// extracted by mini-css-extract-plugin
export var adCard = "_ol-8";
export var adCardBorder = "_ol-5";
export var arbiterButtonIcon = "_ol-p";
export var buttonIcon = "_ol-o";
export var container = "_ol-e";
export var copyButton = "_ol-m";
export var darkGrey = "_ol-u";
export var deliveryDate = "_ol-2";
export var divider = "_ol-n";
export var editModeWrapper = "_ol-7";
export var empty = "_ol-a";
export var errorIcon = "_ol-d";
export var filledCircle = "_ol-4";
export var fulfillmentFooter = "_ol-j";
export var grey = "_ol-s";
export var header = "_ol-i";
export var headerWrapper = "_ol-h";
export var highlighted = "_ol-6";
export var historyEntry = "_ol-3";
export var mobileColumn = "_ol-v";
export var mobileColumnReverse = "_ol-w";
export var orderDetailsContainer = "_ol-g";
export var orderMetadata = "_ol-l";
export var orderMetadataWrapper = "_ol-k";
export var packagesContainer = "_ol-b";
export var product = "_ol-y";
export var productImage = "_ol-z";
export var productInfo = "_ol-x";
export var productTitle = "_ol-10";
export var strikethrough = "_ol-t";
export var tinyText = "_ol-r";
export var title = "_ol-9";
export var trackerCard = "_ol-1";
export var trackerCardWrapper = "_ol-0";
export var trackingContainer = "_ol-f";
export var trackingTitle = "_ol-c";
export var xTinyText = "_ol-q";